// extracted by mini-css-extract-plugin
module.exports = {"anchor":"media_anchor__j93jX","dialogTarget":"media_dialogTarget__VPbBq"};